var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedSquigglyLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 18",
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.45,
    height: 7.383,
    viewBox: "0 0 55.45 7.383",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19",
    d: "m3555.318 690.943-5.006-.327-5.21.053-5.071.407-4.823-.373-5.425-.185-5.174.41-4.8.106-5.218-.541-5.266.441-4.95-.1-.143 6.777 5.3.111 4.988-.417 5.01.519 5.319-.117 5.082-.4 4.821.161 5.288.409 5.244-.43 4.833-.049 5.159.337 4.4-.245v-6.79z",
    transform: "translate(-3504.235 -690.494)",
    style: {
      fill: "#629A41"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedSquigglyLine);
export default __webpack_public_path__ + "static/media/red-squiggly-line.1b90904556890af847e848b28b20d8e5.svg";
export { ForwardRef as ReactComponent };